import {
  AlertTriangle,
  Clapperboard,
  Repeat,
  Siren,
  Sparkles,
  Users,
} from "lucide-react";
import { Link } from "react-router";

import { INCIDENTS_PATH, customerFilmTile } from "../incidents/incidentsModel";
import { KpiCard } from "./FunnelPrimitives";
import { type FunnelSummary, formatInt, formatPct } from "./funnelSummary";

/**
 * Headline tiles above the Funnel chart. "Link-curious" was removed (TRI-56):
 * it only repeated the "Stuck here" count of the first stage.
 */
export function FunnelKpiCards({ data }: { data: FunnelSummary }) {
  const withoutFilm = customerFilmTile(data.customer_film_outcomes);
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
      <KpiCard
        icon={<Users className="size-4" />}
        label="Cohort size"
        value={formatInt(data.cohort_size)}
        sublabel="entered onboarding"
      />
      <KpiCard
        icon={<Clapperboard className="size-4" />}
        label="Reached rated"
        value={formatPct(data.closed_conversion.arrival_to_rated_pct)}
        sublabel="arrival → rated"
      />
      <KpiCard
        icon={<AlertTriangle className="size-4" />}
        label="Unrecovered failures"
        value={formatInt(data.echo_outcomes.unrecovered_echoes)}
        sublabel={`${formatInt(data.echo_outcomes.recovered_echoes)} recovered · ${formatInt(data.echo_outcomes.pending_echoes)} pending`}
      />
      <Link
        to={INCIDENTS_PATH}
        className="group block rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        title="Customers counted once per week: approved, then no film within 72 hours. Pending = approved less than 72 hours ago. Opens the Incidents tab."
      >
        <KpiCard
          icon={<Siren className="size-4" />}
          label="Customers without a film ≤72h"
          value={withoutFilm.value}
          sublabel={withoutFilm.sublabel}
          muted={withoutFilm.muted}
          className="h-full transition-colors group-hover:bg-accent/40"
        />
      </Link>
      <KpiCard
        icon={<Repeat className="size-4" />}
        label="Graduated"
        value={formatInt(data.recurring.graduated)}
        sublabel="≥2 echoes → recurring"
      />
      <KpiCard
        icon={<Sparkles className="size-4" />}
        label="Avg images"
        value={data.image_count.avg == null ? "—" : `≈${data.image_count.avg}`}
        sublabel={`${formatInt(data.image_count.n)} uploaders`}
        muted={data.image_count.avg == null}
      />
    </div>
  );
}
